export const APPLICATION_REQUEST_TIMEOUT = 10000;

// Keep tenant data out of the previous tenant's cache/placeholder during switches.
export const applicationQueryOptions = (tenantId, request, enabled = true) => ({
  queryKey: ['applications', 'list', String(tenantId ?? '')],
  enabled: enabled && Boolean(tenantId),
  queryFn: ({ signal }) => request({ tenantId, signal }),
  retry: false,
  networkMode: 'always',
  placeholderData: undefined,
  staleTime: 15 * 60 * 1000,
  gcTime: 60 * 60 * 1000,
  refetchOnWindowFocus: false,
  select: (response) => {
    if (!Array.isArray(response?.data)) {
      throw new Error('فهرست اپلیکیشن‌ها قابل دریافت نیست');
    }
    return response.data.map((app) => ({
      value: Number(app.id),
      label: app.name,
      description: app.description,
    }));
  },
});
